import { useState } from 'preact/hooks';
import { Icon } from '../Icon';

export const EMOTES = [
    { id: 'wave', label: 'Wave', icon: 'waving-hand01' },
    { id: 'hail', label: 'Hail', icon: 'crown' },
    { id: 'ehen', label: 'Eh-hen', icon: 'thumbs-up' },
];

export function EmoteWheel({ bridge }) {
    const [open, setOpen] = useState(false);
    return (<div class="emote-wheel" onPointerDown={(e) => e.stopPropagation()}>
      {open && EMOTES.map((e) => (<button key={e.id} type="button" class="chip emote-btn" data-emote={e.id} aria-label={e.label} title={e.label} onClick={() => { bridge.emote(e.id); setOpen(false); }}><Icon name={e.icon}/></button>))}
      <button type="button" class="chip emote-btn" aria-label="Emotes" aria-expanded={open} onClick={() => setOpen(!open)}><Icon name="waving-hand01"/></button>
    </div>);
}
